export default {

    getUserStorage: () => { return JSON.parse(JSON.stringify(localStorage.getItem("user")))},
    getUserId: () => { return JSON.parse(JSON.stringify(localStorage.getItem("user_id")))},
    getTokenStorage: () => { return JSON.parse(JSON.stringify(localStorage.getItem("token")))}

}